import { create } from 'zustand';

import { Consultant, ConsultantIndustries } from '@/types/consultant.type';

export interface ConsultantState {
  consultant: Consultant | undefined;
  consultantIndustries: ConsultantIndustries | undefined;
  setConsultant: (consultant: Consultant) => void;
  setConsultantIndustries: (consultantIndustries: ConsultantIndustries) => void;
}

export const useConsultantStore = create<ConsultantState>((set) => ({
  consultant: undefined,
  consultantIndustries: undefined,
  setConsultant: (consultant: Consultant) => set(() => ({ consultant })),
  setConsultantIndustries: (consultantIndustries: ConsultantIndustries) =>
    set(() => ({ consultantIndustries })),
}));
